// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"125b6b39","453":"4e5844a3","455":"a450ca04","977":"78897617"}[chunkId] + ".chunk.js";
};